import React, { createContext, useContext, useEffect, useReducer } from "react";
import { authAPI, setToken, clearToken, getToken } from "../services/api";

const AuthContext = createContext(null);

function userReducer(_, action) {
  if (action.type === "set") return action.user;
  return null;
}

export function AuthProvider({ children }) {
  // null = checking, false = not logged in, object = logged in
  const [user, dispatch] = useReducer(userReducer, null);

  useEffect(() => {
    if (!getToken()) {
      dispatch({ type: "set", user: false });
      return;
    }
    authAPI
      .me()
      .then((r) => dispatch({ type: "set", user: r.data }))
      .catch(() => {
        clearToken();
        dispatch({ type: "set", user: false });
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await authAPI.login(email, password);
    setToken(data.token);
    dispatch({ type: "set", user: data.user });
    return data.user;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch (e) { /* ignore */ }
    clearToken();
    dispatch({ type: "set", user: false });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
